// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, Children, cloneElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Grid from '../Grid';
import GridCol from '../GridCol';

import './ItemList.less';

/**
 * `ItemList` component.
 */
class ItemList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ReorderableGrid: null,
            ReorderableGridCol: null,
        };
    }

    componentDidMount() {
        const { reorderable } = this.props;

        if (reorderable) {
            import(/* webpackChunkName: "react-sortable-hoc" */ 'react-sortable-hoc').then(({ sortableContainer, sortableElement }) => {
                this.setState({
                    ReorderableGrid: sortableContainer(Grid),
                    ReorderableGridCol: sortableElement(GridCol),
                });
            });
        }
    }

    renderNormal({ baseClassName, children, ...props }) {
        return (
            <Grid {...props}>
                {Children.map(children, child => (
                    <GridCol>
                        {cloneElement(child, {
                            className: classNames(
                                `${baseClassName}__item`,
                                child.props.className
                            ),
                        })}
                    </GridCol>
                ))}
            </Grid>
        );
    }

    renderReorderable({ baseClassName, onReorderEnd, children, ...props }) {
        const { ReorderableGrid, ReorderableGridCol } = this.state;

        if (!ReorderableGrid) {
            return null;
        }

        const helperClass = classNames({
            [`${baseClassName}__col--gap-xs`]: props.gap === 'xs',
            [`${baseClassName}__col--gap-sm`]: props.gap === 'sm',
            [`${baseClassName}__col--gap-md`]: props.gap === 'md',
            [`${baseClassName}__col--gap-lg`]: props.gap === 'lg',
            [`${baseClassName}__col--gap-xl`]: props.gap === 'xl',
        });

        return (
            <ReorderableGrid
                axis="xy"
                helperClass={helperClass}
                onSortEnd={onReorderEnd}
                {...props}
            >
                {Children.map(children, (child, index) => (
                    <ReorderableGridCol index={index}>
                        {cloneElement(child, {
                            className: classNames(
                                `${baseClassName}__item`,
                                `${baseClassName}__item--reorderable`,
                                child.props.className
                            ),
                        })}
                    </ReorderableGridCol>
                ))}
            </ReorderableGrid>
        );
    }

    render() {
        const {
            className,
            reorderable,
            onReorderEnd,
            ...props
        } = this.props;

        return (
            <div className={classNames(this.props.baseClassName, className)}>
                {reorderable ? this.renderReorderable({ onReorderEnd, ...props }) : this.renderNormal(props)}
            </div>
        );
    }
}

ItemList.propTypes = {
    /**
     * Enable reorderable view.
     */
    reorderable: PropTypes.bool,
    /**
     * Reorder end handler.
     */
    onReorderEnd: PropTypes.func,
    /**
     * Content of the `ItemList`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

ItemList.defaultProps = {
    reorderable: false,
    onReorderEnd: null,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}item-list`,
};

export default ItemList;



// WEBPACK FOOTER //
// ./components/ItemList/ItemList.js